<template>
  <div class="exhibition_re">
		<div class="title title_1">多种版本满足你的定制化需求</div>
		<div 
			:class="['version_wrap', 'tob_wrap', showTob ? 'active' : '']"
		>
			<div @click="showTob = !showTob" class="version_header">
				<div class="header_left">
					<img class="tob_icon" src="@/assets/menu/ep@2x.png" alt="">
					<p class="tob_name">ToDesk企业版</p>
				</div>
				<svg :class="{ 'rotate2down': !showTob}"  width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M0.142065 4.88383C0.342895 5.11718 0.689899 5.15567 0.936982 4.97201L1.00271 4.91488L4.50049 1.41711L7.99827 4.91488C8.20363 5.12029 8.52836 5.14458 8.76199 4.97201L8.82772 4.91488C9.03357 4.70941 9.05787 4.38416 8.88484 4.15038L8.82772 4.08465L4.91522 0.172147C4.70965 -0.0330191 4.38494 -0.0569735 4.1515 0.115807L4.08577 0.172147L0.173261 4.08465C-0.0451468 4.30163 -0.0587648 4.65049 0.142065 4.88383Z" fill="#BBBBBB"/>
				</svg> 
			</div>
			<div class="version_content">
				<div v-for="bItem in versionListTob" @click="(e) => handleClickBItem(bItem, e)" :to="bItem.link" class="content_item" :key="bItem.key">
					<p class="version_title">
						<img class="version-icon" :src="bItem.icon" alt="">
						{{ bItem.title }}
					</p>
					<div class="text_wrap">
						<p class="text_item" v-for="tItem in bItem.textList" :key="tItem">{{ tItem }}</p>
					</div>
					<div class="content_wrap_bg">
						<img :src="bItem.bgUrl" alt="" draggable="false">
					</div>
					<div class="empty-dom"></div>
					<p class="btn">{{ bItem.btnText }}<i class="el-icon-arrow-right"></i></p>
				</div>
			</div>
		</div>
		<div
			:class="['version_wrap', 'toc_wrap', showToc ? 'active' : '']"
		>
			<div @click="showToc = !showToc" class="version_header">
				<div class="header_left">
					<img class="tob_icon" src="@/assets/menu/solo@2x.png" alt="">
					<p class="tob_name">ToDesk个人版</p>
				</div>
				<svg :class="{ 'rotate2down': !showToc}"  width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M0.142065 4.88383C0.342895 5.11718 0.689899 5.15567 0.936982 4.97201L1.00271 4.91488L4.50049 1.41711L7.99827 4.91488C8.20363 5.12029 8.52836 5.14458 8.76199 4.97201L8.82772 4.91488C9.03357 4.70941 9.05787 4.38416 8.88484 4.15038L8.82772 4.08465L4.91522 0.172147C4.70965 -0.0330191 4.38494 -0.0569735 4.1515 0.115807L4.08577 0.172147L0.173261 4.08465C-0.0451468 4.30163 -0.0587648 4.65049 0.142065 4.88383Z" fill="#BBBBBB"/>
				</svg> 
			</div>
			<div class="version_content">
				<router-link v-for="cItem in versionListToc" :to="cItem.link" :class="['content_item', `content_item_${cItem.key}`]" :key="cItem.key">
					<p class="version_title">
						<img class="version-icon" :src="cItem.icon" alt="">
						{{ cItem.title }}
					</p>
					<div class="text_wrap">
						<p class="text_item" v-for="tItem in cItem.textList" :key="tItem">{{ tItem }}</p>
					</div>
					<div class="content_wrap_bg">
						<img :src="cItem.bgUrl" alt="" draggable="false">
					</div>
					<div class="empty-dom"></div>
					<p class="btn">{{ cItem.btnText }}<i class="el-icon-arrow-right"></i></p>
				</router-link>
			</div>
		</div>
		<div class="title title_2">超过30w+企业的共同信赖</div>
		<div class="swipe_Wrap">
			<div v-for="line in 4" :class="['scroll_bx', `scroll_bx_${line}`]" :key="`line${line}`">
				<img v-for="item in 6" :key="`line${line}-${item}`" :src="require(`@/assets/users/user-line/line-${line}-${item % 3 || 3}.png`)" class="user_icon" alt="">
			</div>
			</div>
		<div class="certificate_main_wrap">
			<div class="bg_color_wrap"></div>
			<div class="title title_3">ToDesk资质证书</div>
			<div class="certificate_wrap">
				<div class="qa_item" v-for="(item,index) in certificate_list" :key="index" @click="showCertificate(index)">
					<img :src="item.icon" :alt="item.title" class="qa_icon" draggable="false">
					<p class="qa_text">{{item.title}}</p>
				</div>
				<transition name="mask">
					<div class="showCertificate" @click="show_certificate=false;allowScroll();" v-if="show_certificate">
						<div class="bx">
							<div class="bx_inner">
								<img @click.stop="()=>{return false}" :src="certificate_img" class="imgCertificate" alt="资质证书" draggable="false">
								<img src="@/assets/certificates/close@2x.png" @click="hideCertificate()" class="closeCertificate" draggable="false" alt="关闭">
							</div>
						</div>
					</div>
				</transition>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: "Exhibition",
  data() {
    return {
			showTob: true,
			showToc: false,
			versionListTob: [
				{
					key: 'standard',
					title: '标准版',
					icon: require('@/assets/home/version-svg/tob-stand-icon.svg'),
					textList: [
						'适用于远程办公、项目开发、连接虚拟机、',
						'访问业务专机',
					],
					btnText: '查看详情',
					bgUrl: 'https://todeskcdnspeed.todesk.com/202308301426356041e025d763e4.png',
					link: '/enterprise'
				},
				{
					key: 'perform_b',
					title: '高性能设计',
					icon: require('@/assets/home/version-svg/tob-perform-icon.svg'),
					textList: [
						'适用于设计制图、建模渲染、游戏开发、视',
						'频剪辑等场景',
					],
					btnText: '查看详情',
					bgUrl: 'https://todeskcdnspeed.todesk.com/202308301427156041e04c302e04.png',
					link: '/solutions/design'
				},
				{
					key: 'tech',
					title: '技术支持',
					icon: require('@/assets/home/version-svg/tob-tech-icon.svg'),
					textList: [
						'适用于客户技术支持、公司IT管理、无人值',
						'守等场景',
					],
					btnText: '查看详情',
					bgUrl: 'https://todeskcdnspeed.todesk.com/202308301427536041e06fd817fc.png',
					link: 'https://enterprise.todesk.com/solutions/remoteSupport'
				},
			],
			versionListToc: [
				{
					key: 'solo',
					title: '个人版',
					icon: require('@/assets/home/version-svg/toc-per-icon.svg'),
					textList: [
						'支持5大系统畅享互联、1080p高清画质',
					],
					btnText: '查看详情',
					bgUrl: 'https://todeskcdnspeed.todesk.com/202308301501076041e7dddd2e5c.png',
					link: '/solo'
				},
				{
					key: 'pro',
					title: '专业版',
					icon: require('@/assets/home/version-svg/toc-pro-icon.svg'),
					textList: [
						'2K30帧超清画质，VIP专属高速机房，全',
						'球200+机房节点'
					],
					btnText: '查看详情',
					bgUrl: 'https://todeskcdnspeed.todesk.com/202308301501236041e7ed0269ac.png',
					link: '/solo'
				},
				{
					key: 'game',
					title: '游戏版',
					icon: require('@/assets/home/version-svg/toc-game-icon.svg'),
					textList: [
						'最高支持4K60帧/2K144帧，支持PS、',
						'Xbox游戏手柄'
					],
					btnText: '查看详情',
					bgUrl: 'https://todeskcdnspeed.todesk.com/202308301501416041e7fea725d8.png',
					link: '/game'
				},
				{
					key: 'perform_c',
					title: '性能版',
					icon: require('@/assets/home/version-svg/toc-perform-icon.svg'),
					textList: [
						'最高支持4K60帧/2K144帧，',
						'自带真彩、虚拟屏、多屏等专属权益',
					],
					btnText: '查看详情',
					bgUrl: 'https://todeskcdnspeed.todesk.com/202308301501536041e809dac474.png',
					link: '/perform'
				}
			],
			certificate_list:[
        		{ title:'麒麟软件NeoCertify认证',icon:'https://todeskcdnspeed.todesk.com/202304231653455f9fd07292cea4.png', pic:'https://todeskcdnspeed.todesk.com/202303161212405f6fcabea872cc.png' },
        		{ title:'信息安全管理体系认证', icon:'https://todeskcdnspeed.todesk.com/202303161443555f6fec8e1d9a8c.png', pic:'https://todeskcdnspeed.todesk.com/2024011517382560ef8c682f03f4.png' },
        		{ title:'质量管理体系认证', icon:'https://todeskcdnspeed.todesk.com/202304231655285f9fd0d4c74b38.png', pic:'https://todeskcdnspeed.todesk.com/2024011517374360ef8c40803514.png' },
				{ title:'统信认证', icon:'https://todeskcdnspeed.todesk.com/202304231655515f9fd0eaa02fc4.png', pic:'https://todeskcdnspeed.todesk.com/202303161212105f6fcaa2e8fbec.png' },
        		{ title:'中科方德认证', icon:'https://todeskcdnspeed.todesk.com/202304231656145f9fd10000952c.png', pic:'https://todeskcdnspeed.todesk.com/202303161211465f6fca8b49deb0.png' },
				{ title:'软件企业证书', icon:'https://todeskcdnspeed.todesk.com/202304231656275f9fd10c6e8944.png', pic:'https://todeskcdnspeed.todesk.com/202303161211055f6fca64976fe4.png' },
				{ title:'上海软件行业协会', icon:'https://todeskcdnspeed.todesk.com/202303161454215f6feee2480b48.png', pic:'https://todeskcdnspeed.todesk.com/202303161500185f6ff036d1d7e4.png' },
				{ title:'卓信大数据', icon:'https://todeskcdnspeed.todesk.com/202303161454445f6feef85a6244.png', pic:'https://todeskcdnspeed.todesk.com/202303161501415f6ff085dc6c98.png' },
				{ title:'软件产品证书', icon:'https://todeskcdnspeed.todesk.com/202303161444435f6fecbb4a614c.png', pic:'https://todeskcdnspeed.todesk.com/202303161214115f6fcb16012904.png' },
				{ title:'信创技术活动单位', icon:'https://todeskcdnspeed.todesk.com/202303161445055f6fecd0c1b5d0.png', pic:'https://todeskcdnspeed.todesk.com/202308221153526037af17e22cac.png' },
				{ title:'信息系统安全等级保护备案证明', icon:'https://todeskcdnspeed.todesk.com/202303161455045f6fef0bcfb11c.png', pic:'https://todeskcdnspeed.todesk.com/202303161502295f6ff0b3f69a08.png' },
				{ title:'高新技术企业', icon:'https://todeskcdnspeed.todesk.com/202303221825455f77a954116138.png', pic:'https://todeskcdnspeed.todesk.com/202303311425075f82c453af8b98.png' },
				{ title: '海光合作认证', icon: 'https://todeskcdnspeed.todesk.com/20230815101643602ecc52e5abe8.png', pic: 'https://todeskcdnspeed.todesk.com/20230815102620602ece78a4066c.png'},
				{
					title: "环境管理体系认证",
					icon: "https://todeskcdnspeed.todesk.com/2024011517401660ef8cd247e58c.png",
					pic: "https://todeskcdnspeed.todesk.com/2024011517385560ef8c84d8b1ec.png",
				},
				{
					title: "职业健康安全管理体系认证",
					icon: "https://todeskcdnspeed.todesk.com/2024011517394060ef8cafd92ed0.png",
					pic: "https://todeskcdnspeed.todesk.com/2024011517392360ef8c9fef5024.png",
				},
				{
          title: "信息技术服务管理体系认证",
          icon: "https://todeskcdnspeed.todesk.com/2024020110323261048ceb663774.png",
          pic: "https://todeskcdnspeed.todesk.com/2024020110443161048f99e2ee8c.png",
        },
			],
      show_certificate:false,
		}
  },
	computed: {},
  mounted() {},
  methods: {
		hideCertificate(){
			this.allowScroll();
			this.show_certificate = false;
    },
    showCertificate(val){
			if(val === -1){
				allowScroll() 
				this.show_certificate = false;
			}else{
				this.stopScroll();
				this.certificate_img = this.certificate_list[val].pic;
				this.show_certificate = true;
			}
		},
		//阻止body滚动
    stopScroll() {
      document.body.classList.add('body-stop-scroll')
    },
    allowScroll() {
      document.body.classList.remove('body-stop-scroll')
    },
		handleClickBItem(bItem, e) {
			const url = bItem.link || '/'
			if (bItem.key === 'tech') {
				window.open(url)
				return
			}
			this.$router.push(url)
		}
	}
};
</script>

<style scoped lang="less">
* {
	box-sizing: border-box;
}
.exhibition_re {
	width: 100%;
	// min-height: 1344px;
	background-color: rgba(246, 247, 248, 1);
	overflow: hidden;
	position: relative;
	.title {
		width: 100%;
		margin: 0 auto;
		text-align: center;
		font-family: 'PingFang SC';
		color: #000000;
		&_1 {
			padding-top: 38px;
			font-weight: 600;
			font-size: 24px;
			line-height: 34px;
		}
		&_2 {
			font-weight: 600;
			font-size: 26px;
			line-height: 36px;
			padding-top: 60px;
		}
		&_3 {
			padding-top: 46px;
			font-weight: 600;
			font-size: 26px;
			line-height: 36px;
		}
	}
	.ex_prev_btn, .ex_next_btn {
		display: flex;
		align-items: center;
		justify-content: center;
		img {
			display: block;
			margin-left: 2px;
		}
	}
	.ex_prev_btn {
		width: 48px;
		height: 48px;
		position: absolute;
		top: 292px;
		left: 20px;
		background-color: rgba(0, 0, 0, 0.2);
		border-radius: 50%;
		cursor: pointer;
		&:hover {
			background-color: rgba(0, 0, 0, 0.35);
		}
	}
	.ex_next_btn {
		width: 48px;
		height: 48px;
		position: absolute;
		top: 292px;
		right: 20px;
		border-radius: 50%;
		background-color: rgba(0, 0, 0, 0.2);
		cursor: pointer;
		transform: rotate(180deg);
		&:hover {
			background-color: rgba(0, 0, 0, 0.35);
		}
	}
	.version_wrap {
		overflow: hidden;
		height: 56px;
		will-change: auto;
		transition: height .3s, background-color .3s;
		background: linear-gradient(180deg, #F6F9FF 0%, #FFF 100%);
		display: flex;
		flex-direction: column;
		.version_header {
			width: 100%;
			height: 56px;
			border-top: 1px solid #FFF;
			background: linear-gradient(180deg, #F6F9FF 0%, #FFF 100%);
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 16px 0 19px;
			flex-shrink: 0;
			box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
			.header_left {
				display: flex;
			}
			svg {
				transform: rotate(0deg);
				transition: transform .2s;
			}
			.rotate2down {
				transform: rotate(180deg);
			}
		}
		.version_content {
			width: 100%;
			height: 100%;
			box-sizing: border-box;
			padding: 20px 20px 0;
			.content_item {
				position: relative;
				width: 100%;
				height: 177px;
				display: flex;
				flex-direction: column;
				background-color: rgb(243, 247, 253);
				padding: 20px 0 17px 28px;
				border: 1px solid rgba(255, 255, 255, 1);
				border-radius: 16px;
				box-shadow: 0px 15px 20px 0px rgba(206, 219, 244, 0.4);
				margin-top: 24px;
				&:first-of-type {
					margin-top: 0;
				}
				.version-icon {
					padding-top: 2px;
					width: 24px;
					height: auto;
					margin-right: 10px;
				}
				.content_wrap_bg {
					img {
						width: 90px;
						height: auto;
						display: block;
					}
				}
				.version_title {
					display: flex;
					align-items: center;
					color: #000;
					font-family: PingFang SC;
					font-size: 20px;
					font-weight: 500;
				}
				.text_wrap {
					margin-top: 11px;
					.text_item {
						color: #747576;
						font-family: PingFang SC;
						font-size: 14px;
						font-weight: 400;
						line-height: 24px;
					}
				}
				.empty-dom {
					flex: 1;
				}
				.btn {
					display: flex;
					align-items: center;
					font-family: PingFang SC;
					font-size: 16px;
					font-weight: 400;
					line-height: 24px;
					color: rgba(0, 112, 249, 1);
					.el-icon-arrow-right {
						padding-top: 2px;
						margin-left: 3px;
						font-size: 10px;
					}
				}
				.content_wrap_bg {
					position: absolute;
					bottom: 0;
					right: 0;
					img {
						width: 90px;
						height: auto;
						display: block;
					}
				}
			}
		}
		&.active {
			.version_header {
				background: rgb(246, 249, 255);
				box-shadow: unset;
			}
			.version_content {
				position: relative;
				&::before {
					content: "";
					width: 335px;
					height: 1px;
					background-color: #e5e6eb;
					position: absolute;
					top: 0px;
					left: 50%;
					transform: translateX(-50%);
				}
			}
		}
		&.tob_wrap {
			margin-top: 21px;
			&.active {
				height: 700px;
			}
			.tob_icon {
				width: 25px;
				height: auto;
				display: block;
				margin-right: 8px;
			}
			.tob_name {
				color: #131314;
				font-family: PingFang SC;
				font-size: 16px;
				font-weight: 600;
			}
		}
		&.toc_wrap {
			&.active {
				height: 900px;
			}
			.tob_icon {
				width: 25px;
				height: auto;
				display: block;
				margin-right: 8px;
			}
			.tob_name {
				color: #131314;
				font-family: PingFang SC;
				font-size: 16px;
				font-weight: 600;
			}
			.content_item {
				&_solo {
					background-color: rgb(242, 248, 255);
				}
				&_pro {
					background-color: rgb(244, 249, 253);
				}
				&_game {
					background-color: rgb(247, 244, 251);
				}
				&_perform_c {
					background-color: rgb(254, 250, 246);
				}
			}
		}
	}
	.swipe_Wrap {
		width: 100%;
		overflow: hidden;
		position: relative;
		margin-top: 30px;
		@keyframes wordsLoop {
			0% {
				transform: translateX(0);
				-webkit-transform: translateX(0);
			}
			100% {
				transform: translateX(-50%);
				-webkit-transform: translateX(-50%);
			}
		}
		@-webkit-keyframes wordsLoop {
			0% {
				transform: translateX(0);
				-webkit-transform: translateX(0);
			}
			100% {
				transform: translateX(-50%);
				-webkit-transform: translateX(-50%);
			}
		}
		.scroll_bx{
			background: #F8F9FA;
			width: fit-content;
			display: flex;
			align-items: center;
			height: 50px;
			justify-content: center;
			padding-right: 20px;
			position: relative;
			&_1 {
				margin-left: -7px;
				-webkit-animation: wordsLoop 65s linear infinite;
				animation: wordsLoop 65s linear infinite;
			}
			&_2 {
				margin-left: -24px;
				-webkit-animation: wordsLoop 70s linear infinite;
				animation: wordsLoop 70s linear infinite;
			}
			&_3 {
				margin-left: -13px;
				-webkit-animation: wordsLoop 63s linear infinite;
				animation: wordsLoop 63s linear infinite;
			}
			&_4 {
				margin-left: -37px;
				-webkit-animation: wordsLoop 58s linear infinite;
				animation: wordsLoop 58s linear infinite;
			}
			.user_icon{
				height: 50px;
				width: auto;
			}
			.user_icon:last-of-type{
				margin-right: 0;
			}
		}
	}
	.certificate_main_wrap {
		width: 100%;
		height: auto;
		padding-bottom: 50px;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-position: bottom center;
		position: relative;
		background: linear-gradient(to bottom, #F8F9FA 0%, #dde7ef 100%);
		.bg_color_wrap {
			content: '';
			display: block;
			width: 100%;
			height: 100%;
			background-repeat: no-repeat;
			background-size: auto 179px;
			background-position: bottom center;
			background-image: url('https://todeskcdnspeed.todesk.com/202304231614135f9fc79c5ff1e4.png');
			position: absolute;
			top: 0;
			z-index: 0;
		}
	}
	.certificate_wrap {
		z-index: 1;
		position: relative;
		box-sizing: border-box;
		width: 335px;
		margin: 30px auto 0;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		.qa_item{
			display: flex;
			justify-content: center;
			flex-direction: column;
			align-items: center;
			width: 101px;
			height: 114px;

			background: #FFFFFF;
			box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
			border-radius: 12px;
			box-sizing: border-box;
			transition: transform .3s;
			margin-bottom: 10px;
		}
		.qa_item:active{
			transform: translateY(-6px);
			box-shadow: 0 10px 26px rgba(21, 18, 53, 0.18);
			.qa_text{
				color: #0B80FE;
			}
		}
		.qa_icon{
			width: auto;
			height: 34px;
		}
		.qa_text{
			margin-top: 14px;
			font-family: 'PingFang SC';
			font-weight: 400;
			font-size: 12px;
			line-height: 17px;
			text-align: center;
			color: #7F7F7F;
		}
		.showCertificate {
			position: fixed;
			left: 0;
			top: 0;
			width: 100vw;
			height: 100vh;
			background: rgba(0, 9, 23, 0.69);
			z-index: 10;
			.bx {
				width: 100%;
				height: 96%;
				margin-top: 50px;
				display: flex;
				align-items: center;
				justify-content: center;
				.bx_inner {
					width: 300px;
					position: relative;
				}
				.imgCertificate {
					width: 280px;
					height: auto;
				}
				.closeCertificate {
					position: absolute;
					width: 20px;
					height: auto;
					right: -10px;
					top: 0;
				}
			}
		}
		// 过渡效果
		.certificatefade-enter-active,
		.certificatefade-leave-active {
			transition: opacity 0.3s;
		}
		.certificatefade-enter,
		.certificatefade-leave-to {
			opacity: 0;
		}
	}
}
</style>

<style>
.body-stop-scroll {
	height: 100vh;
	overflow: hidden;
}
</style>